export default __webpack_public_path__ + "static/media/loading-trans.f924c63e.gif";